import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import $ from '@sparta.global.vendors/jquery';
import '@sparta.global.vendors/lodash';
import spartaBootstrapUtility from '@sparta.global.utilities/sparta-bootstrap-utility/dist/es5.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es5.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es5.js';
import spartaTransportUtility from '@sparta.global.utilities/sparta-transport-utility/dist/es5.js';
import spartaGlobalFunctions from '@sparta.global.utilities/sparta-global-functions-utility/dist/es5.js';
import spartaExperienceUtility from '@sparta.global.utilities/sparta-experience-utility/dist/es5.js';
import spartaMessageUtility from '@sparta.global.utilities/sparta-messaging-utility/dist/es5.js';
import renderModuleTemplate from '@sparta.global.templates/render-module-template/dist/es5.js';
var Communicator = /*#__PURE__*/function () {
  function Communicator(options) {
    _classCallCheck(this, Communicator);
    var defaults = {
      public: "document",
      $public: $(),
      private: "",
      $private: $(),
      namespace: "generic"
    };
    this.settings = {};
    this.settings.events = defaults;
    $.extend(this.settings, options);
    this.communication = this.settings.events;
    this.communication.$private = this.settings.$target;
    this.communication.$public = $(this.communication.public);
  }

  // targeting the following code for deprecation.
  // After August release we will delete beacon API from sparta-module-utility
  return _createClass(Communicator, [{
    key: "beacon",
    value: function beacon(action, params) {
      // Wiring up the beacon to work temporarily.
      // Will rewire to use the SpartaEvent pattern.
      //
      var utilities = {
        array: {
          slice: function slice(array) {
            return Array.prototype.slice.apply(array, Array.prototype.slice.call(arguments, 1));
          },
          remove: function remove(array, item) {
            var i,
              l = array.length;
            for (i = 0; i < l; i++) {
              if (array[i] === item) {
                array.splice(i, 1);
                i--;
              }
            }
          }
        },
        functional: function functional(f) {
          var slice = utilities.array.slice,
            prepended = [],
            appended = [],
            boundTo = null,
            before,
            after;
          function wrapper() {
            if (before != null) {
              before.apply(null, arguments);
            }
            var result = f.apply(boundTo, prepended.concat(slice(arguments), appended));
            if (after != null) {
              after.call(null, result);
            }
            return result;
          }
          wrapper.bindTo = function (to) {
            boundTo = to;
            return wrapper;
          };
          wrapper.append = function () {
            appended = slice(arguments);
            return wrapper;
          };
          wrapper.prepend = function () {
            prepended = slice(arguments);
            return wrapper;
          };
          wrapper.before = function (f) {
            before = f;
            return wrapper;
          };
          wrapper.after = function (f) {
            after = f;
            return wrapper;
          };
          return wrapper;
        }
      };
      if (typeof params.context !== "string") return;
      var $location = params.scope === "public" ? this.communication.$public : this.communication.$private;
      if (action === "listen" && typeof params.callback === "function") {
        $location.on(params.context + "." + this.communication.namespace, utilities.functional(params.callback).bindTo(params.caller));
      }
      if (action === "emit") {
        $location.trigger(params.context + "." + this.communication.namespace, [params.data]);
      }
    }
  }, {
    key: "listen",
    value: function listen(params) {
      this.beacon("listen", params);
    }
  }, {
    key: "emit",
    value: function emit(params) {
      this.beacon("emit", params);
    }
  }]);
}();
var Controller = /*#__PURE__*/function (_Communicator) {
  function Controller(options) {
    var _this;
    _classCallCheck(this, Controller);
    _this = _callSuper(this, Controller, [options.settings]);
    var defaults = {};
    _this.settings = defaults;
    $.extend(_this.settings, options.settings);
    _this.model = options.model;
    return _this;
  }
  _inherits(Controller, _Communicator);
  return _createClass(Controller);
}(Communicator);
var Model = /*#__PURE__*/function (_Communicator2) {
  function Model(options) {
    var _this2;
    _classCallCheck(this, Model);
    _this2 = _callSuper(this, Model, [options.settings]);
    var defaults = {};
    _this2.settings = defaults;
    $.extend(_this2.settings, options.settings);
    _this2.protected = [];
    _this2._initialize();
    return _this2;
  }
  _inherits(Model, _Communicator2);
  return _createClass(Model, [{
    key: "data",
    get: function get() {
      return this.protected;
    },
    set: function set(value) {
      this.protected = value;
    }
  }, {
    key: "_initialize",
    value: function _initialize() {
      // Model initialization code here.
    }
  }]);
}(Communicator);
var View = /*#__PURE__*/function (_Communicator3) {
  function View(options) {
    var _this3;
    _classCallCheck(this, View);
    _this3 = _callSuper(this, View, [options.settings]);
    var defaults = {};
    _this3.settings = defaults;
    _this3.settings = $.extend(defaults, options.settings);
    _this3.model = options.model;
    _this3._initialize();
    return _this3;
  }
  _inherits(View, _Communicator3);
  return _createClass(View, [{
    key: "_initialize",
    value: function _initialize() {
      // View initialization code here.
    }
  }]);
}(Communicator); // Third party imports
function registerModuleClass(_ref) {
  var moduleClass = _ref.moduleClass,
    moduleConfig = _ref.moduleConfig;
  spartaBootstrapUtility.registerModuleClass({
    moduleClass: moduleClass,
    moduleConfig: moduleConfig
  });
}

/**
 * Validate and retrieve the target element
 * @param {string|HTMLElement} target Target element
 * @returns {HTMLElement} Validated target element
 */
function getMountElement(target) {
  var element = target instanceof HTMLElement ? target : document.querySelector(target);
  if (!(element instanceof HTMLElement)) {
    throw new Error("Target ".concat(target, " isn't a valid HTML element or query selector string."));
  }
  return element;
}

/**
 * Verify and create a new module Id if required
 * @param {string} module Id
 * @returns {string} same or new module Id
 */
function getModuleUniqueId(moduleId) {
  if (!document.getElementById(moduleId)) {
    return moduleId;
  }
  var moduleCount = 0;
  while (document.getElementById(moduleId + ++moduleCount));
  return moduleId + moduleCount;
}
var Module = /*#__PURE__*/function () {
  function Module(options) {
    _classCallCheck(this, Module);
    if (options && Object.keys(options).length) {
      var defaults = {
        target: null,
        $target: $(),
        debug: false,
        events: {
          namespace: "module"
        }
      };
      this.settings = _objectSpread(_objectSpread({}, defaults), options);
      this.settings.target = this.settings.class || this.settings.target;
      this.settings.$target = $(this.settings.target); // How can we get rid of $target? If we dont then we will never be able to get rid of jQuery
      this.settings.SPARTA_READY = this.settings.$target.data("sparta-load") === "primary" ? "SPARTA_GLOBAL_READY.spartaBootstrapUtility" : "SPARTA_SECONDARY_READY.spartaBootstrapUtility";

      /*  Gather all appropriate data attributes associated with this module.
          These can then be accessed as overrides on default actions/behaviors/values.
      */
      for (var data in this.settings.data) {
        if (this.settings.$target.data(data)) {
          this.settings.data[data] = this.settings.$target.data(data);
        }
      }
      this.model = new Model({
        settings: this.settings
      });
      this.view = new View({
        model: this.model,
        settings: this.settings
      });
      this.controller = new Controller({
        model: this.model,
        settings: this.settings
      });
      this.Events = spartaEventsUtility;
      this.Store = spartaStoreUtility;
      this.Transport = spartaTransportUtility;
      this.SpartaFunctions = spartaGlobalFunctions;
      this.Experience = spartaExperienceUtility;
      this.Message = spartaMessageUtility;
      this.isWidget = !!spartaStoreUtility.getData("isWidget");
      if (this.isWidget) {
        this.widgetInfo = options.widgetInfo;
      }
      this.applicationContext = spartaStoreUtility.getData("applicationContext", this.widgetInfo);
      this.applicationContainer = spartaStoreUtility.getData("applicationContainer", this.widgetInfo);
      this.spaParams = spartaStoreUtility.getData("spaParams");
      this.eventDelegatorString = this.applicationContext ? "#".concat(this.applicationContext.id) : "[data-sparta-container]";
      this.params = this.settings.$target.data("module-parameters");
      this.vuex = options.vuex;
      this.vuexStore = options.vuexStore;

      // sets module info (name/version/options)
      this.settings.moduleInfo = {
        name: this.settings.$target.data("module"),
        version: this.settings.$target.data("version")
      };

      // options are set on applicationContainer in 'data-sparta-overrides' via Bootstrap-utility
      this.settings.moduleInfo.options = this.Store.getData("applicationOptions", this.widgetInfo)[this.settings.moduleInfo.name];
      spartaBootstrapUtility.register(this);
    }
  }

  /**
   * Loads on-demand data sources asynchronously and replaces data source reference with loaded data object
   */
  return _createClass(Module, [{
    key: "loadDataSourceAsync",
    value: (function () {
      var _loadDataSourceAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(jcrReference) {
        var spaParams, dynamicImport, jcrEntry, loadedData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof jcrReference === "string")) {
                _context.next = 10;
                break;
              }
              // const onDemandJcrLoader = window.dynamicImportMap.jcrs.onDemand[jcrReference]
              spaParams = spartaStoreUtility.getData("spaParams");
              dynamicImport = spaParams["dynamicImportMap"];
              if (dynamicImport) {
                jcrEntry = dynamicImport.jcrs.find(function (a) {
                  return a.name === jcrReference;
                });
              }
              if (!(jcrEntry === undefined)) {
                _context.next = 6;
                break;
              }
              throw new Error("ON-DEMAND JCR NOT FOUND: ".concat(jcrReference));
            case 6:
              _context.next = 8;
              return jcrEntry.loader();
            case 8:
              loadedData = _context.sent;
              return _context.abrupt("return", loadedData.default);
            case 10:
              if (!(_typeof(jcrReference) === "object")) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return", jcrReference);
            case 12:
              throw new Error("ON-DEMAND JCR REFERENCE UNKNOWN: ".concat(jcrReference));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function loadDataSourceAsync(_x) {
        return _loadDataSourceAsync.apply(this, arguments);
      }
      return loadDataSourceAsync;
    }()
    /**
     * Mounts a set of module objects (or single object) to the given selectors/elements.
     *
     * Schema:
     * (required) module: reference of the module to mount
     * (required) target: string (or HTMLElement) of the element to mount the module to
     * (optional) context: object of dataSources and/or params to compile the module with.
     * dataSource values can either be relative-pathed URLs or objects, and any URLs provided will be
     * fully resolved as objects.
     * params values must be fully resolved.
     *
     * Advanced:
     * (optional) version: hardcoded version of the module to load, such as '1.0.0'.
     *
     *
     * Usage #1: module is an Array of modules to mount
     * this.mountAll([{
     *   module: 'sparta-demo/global-nav-module',
     *   target: '#some-selector',
     *   context: {
     *     dataSources: {
     *       data1: '/sparta-demo/some/path/file.json'
     *     },
     *     params: {
     *       foo: 'bar'
     *     }
     *   }
     * }]);
     *
     * Usage #2: module is a single object that represents a single module to mount
     * this.mountAll({
     *   module: 'sparta-demo/global-nav-module',
     *   target: '#some-selector',
     *   context: {
     *     dataSources: {
     *       data1: '/sparta-demo/some/path/file.json'
     *     },
     *     params: {
     *       foo: 'bar'
     *     }
     *   }
     * });
     *
     * @param {Array|Object} module An array (or single object) of modules to load.
     * @memberof Module
     * @returns {Promise}
     */
    )
  }, {
    key: "mountAll",
    value: (function () {
      var _mountAll = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(modules) {
        var _this4 = this;
        var moduleArray, spaParams, dynamicImport, widgetInfo, _iterator, _step, _loop;
        return _regeneratorRuntime.wrap(function _callee2$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              moduleArray = Array.isArray(modules) ? modules : [modules];
              spaParams = spartaStoreUtility.getData("spaParams");
              dynamicImport = spaParams["dynamicImportMap"];
              widgetInfo = this.widgetInfo || [];
              _iterator = _createForOfIteratorHelper(moduleArray);
              _context4.prev = 5;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var moduleDef, module, target, context, childModules, moduleEntry, _yield$moduleEntry$lo, _yield$moduleEntry$lo2, loadedOnDemandModuleData, moduleConfig, _iterator2, _step2, _loop2, moduleRenderContext, moduleRenderData, html, element, moduleClass;
                return _regeneratorRuntime.wrap(function _loop$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      moduleDef = _step.value;
                      module = moduleDef.module, target = moduleDef.target, context = moduleDef.context, childModules = moduleDef.childModules;
                      if (dynamicImport) {
                        moduleEntry = dynamicImport.modules.find(function (a) {
                          return a.name === module;
                        });
                      }
                      if (!(moduleEntry === undefined)) {
                        _context3.next = 5;
                        break;
                      }
                      throw new Error("ERROR - ON-DEMAND MODULE NOT FOUND: ".concat(module));
                    case 5:
                      _context3.next = 7;
                      return moduleEntry.loader();
                    case 7:
                      _yield$moduleEntry$lo = _context3.sent;
                      _yield$moduleEntry$lo2 = _slicedToArray(_yield$moduleEntry$lo, 1);
                      loadedOnDemandModuleData = _yield$moduleEntry$lo2[0];
                      if (loadedOnDemandModuleData) {
                        _context3.next = 12;
                        break;
                      }
                      throw new Error("ERROR - ON-DEMAND MODULE FAILED TO LOAD: ".concat(module));
                    case 12:
                      moduleConfig = loadedOnDemandModuleData.moduleConfig; // Process child modules
                      if (!(childModules && childModules.length)) {
                        _context3.next = 30;
                        break;
                      }
                      _iterator2 = _createForOfIteratorHelper(childModules);
                      _context3.prev = 15;
                      _loop2 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop2() {
                        var childModule, childModuleName, childModuleContext, childModuleEntry, _yield$childModuleEnt, _yield$childModuleEnt2, childModuleData, childModuleConfig;
                        return _regeneratorRuntime.wrap(function _loop2$(_context2) {
                          while (1) switch (_context2.prev = _context2.next) {
                            case 0:
                              childModule = _step2.value;
                              childModuleName = childModule.module;
                              childModuleContext = childModule.context;
                              childModuleEntry = dynamicImport.modules.find(function (a) {
                                return a.name === childModuleName;
                              });
                              if (!(childModuleEntry === undefined)) {
                                _context2.next = 6;
                                break;
                              }
                              throw new Error("ERROR - ON-DEMAND MODULE'S CHILD MODULE NOT FOUND: Module - ".concat(module, ", CHILD MODULE - ").concat(childModuleName));
                            case 6:
                              _context2.next = 8;
                              return childModuleEntry.loader();
                            case 8:
                              _yield$childModuleEnt = _context2.sent;
                              _yield$childModuleEnt2 = _slicedToArray(_yield$childModuleEnt, 1);
                              childModuleData = _yield$childModuleEnt2[0];
                              if (childModuleData) {
                                _context2.next = 13;
                                break;
                              }
                              throw new Error("ERROR - ON-DEMAND MODULE'S CHILD MODULE FAILED TO LOAD:  Module - ".concat(module, ", CHILD MODULE - ").concat(childModuleName));
                            case 13:
                              childModuleConfig = childModuleData.moduleConfig; // Creare child module render context
                              _context2.t0 = Object;
                              _context2.t1 = childModule;
                              _context2.next = 18;
                              return _this4.createModuleRenderContext(childModuleContext, childModuleConfig);
                            case 18:
                              _context2.t2 = _context2.sent;
                              _context2.t0.assign.call(_context2.t0, _context2.t1, _context2.t2);
                              // Register Child module class
                              spartaBootstrapUtility.registerModuleClass({
                                moduleClass: childModuleData.default,
                                moduleConfig: childModuleConfig
                              });
                            case 21:
                            case "end":
                              return _context2.stop();
                          }
                        }, _loop2);
                      });
                      _iterator2.s();
                    case 18:
                      if ((_step2 = _iterator2.n()).done) {
                        _context3.next = 22;
                        break;
                      }
                      return _context3.delegateYield(_loop2(), "t0", 20);
                    case 20:
                      _context3.next = 18;
                      break;
                    case 22:
                      _context3.next = 27;
                      break;
                    case 24:
                      _context3.prev = 24;
                      _context3.t1 = _context3["catch"](15);
                      _iterator2.e(_context3.t1);
                    case 27:
                      _context3.prev = 27;
                      _iterator2.f();
                      return _context3.finish(27);
                    case 30:
                      _context3.next = 32;
                      return _this4.createModuleRenderContext(context, moduleConfig, childModules);
                    case 32:
                      moduleRenderContext = _context3.sent;
                      moduleRenderData = {
                        env: _this4.spaParams.siteParams.env,
                        site: {
                          global: _this4.spaParams.global,
                          params: _this4.spaParams.siteParams
                        },
                        page: {
                          parameters: _this4.spaParams.pageParams
                        },
                        language: _this4.spaParams.language,
                        assetPath: "",
                        module: moduleRenderContext,
                        partials: moduleConfig.partials,
                        helpers: moduleConfig.helpers
                      };
                      html = renderModuleTemplate.render(moduleRenderData); // Inject the rendered HTML into the DOM
                      element = getMountElement(target);
                      element.innerHTML += html;
                      spartaBootstrapUtility.addPreventDefaultForLinks(element);
                      moduleClass = loadedOnDemandModuleData.default;
                      spartaBootstrapUtility.registerModuleClass({
                        moduleClass: moduleClass,
                        moduleConfig: moduleConfig
                      });
                    case 40:
                    case "end":
                      return _context3.stop();
                  }
                }, _loop, null, [[15, 24, 27, 30]]);
              });
              _iterator.s();
            case 8:
              if ((_step = _iterator.n()).done) {
                _context4.next = 12;
                break;
              }
              return _context4.delegateYield(_loop(), "t0", 10);
            case 10:
              _context4.next = 8;
              break;
            case 12:
              _context4.next = 17;
              break;
            case 14:
              _context4.prev = 14;
              _context4.t1 = _context4["catch"](5);
              _iterator.e(_context4.t1);
            case 17:
              _context4.prev = 17;
              _iterator.f();
              return _context4.finish(17);
            case 20:
              _context4.next = 22;
              return spartaBootstrapUtility.createAndInitModules(widgetInfo);
            case 22:
            case "end":
              return _context4.stop();
          }
        }, _callee2, this, [[5, 14, 17, 20]]);
      }));
      function mountAll(_x2) {
        return _mountAll.apply(this, arguments);
      }
      return mountAll;
    }())
  }, {
    key: "resolveModulesDataSources",
    value: function () {
      var _resolveModulesDataSources = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dataSourcesMap) {
        var _this5 = this;
        var dataSourceKeys, dataSourcePromiseArray, dataSourceResults;
        return _regeneratorRuntime.wrap(function _callee3$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              dataSourcesMap = dataSourcesMap || {};
              dataSourceKeys = Object.keys(dataSourcesMap);
              dataSourcePromiseArray = [];
              dataSourceKeys.forEach(function (key) {
                if (!_this5.spaParams) _this5.spaParams = spartaStoreUtility.getData("spaParams");
                var language = _this5.spaParams.language;
                var jcrReference = dataSourcesMap[key][language] || dataSourcesMap[key];
                dataSourcePromiseArray.push(_this5.loadDataSourceAsync(jcrReference));
              });

              // Wait for all the data sources to load
              _context5.next = 6;
              return Promise.all(dataSourcePromiseArray);
            case 6:
              dataSourceResults = _context5.sent;
              dataSourceKeys.forEach(function (key, index) {
                dataSourcesMap[key] = dataSourceResults[index];
              });
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee3);
      }));
      function resolveModulesDataSources(_x3) {
        return _resolveModulesDataSources.apply(this, arguments);
      }
      return resolveModulesDataSources;
    }()
  }, {
    key: "createModuleRenderContext",
    value: function () {
      var _createModuleRenderContext = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context, moduleConfig) {
        var childModules,
          uniqueId,
          moduleRenderContext,
          paramsConfigProperties,
          _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              childModules = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : null;
              _context6.next = 3;
              return this.resolveModulesDataSources(context.dataSources);
            case 3:
              uniqueId = getModuleUniqueId(moduleConfig.id);
              moduleRenderContext = _objectSpread(_objectSpread({
                config: _objectSpread(_objectSpread({}, moduleConfig), {}, {
                  id: uniqueId
                }),
                params: _objectSpread({}, context.params)
              }, context.params), {}, {
                dataSources: context.dataSources,
                childModules: childModules
              }); // Populate params with default and overridden entries
              moduleConfig.moduleParams.map(function (param) {
                moduleRenderContext.params[param.name] = moduleRenderContext.params[param.name] !== undefined ? moduleRenderContext.params[param.name] : param.default ? param.default : "";
              });

              // Populate params with selected module config properties
              paramsConfigProperties = ["moduleName", "version", "moduleParams", "viewPort", "id", "nameSpace", "tag", "components", "semantic"];
              paramsConfigProperties.map(function (propertyName) {
                if (moduleConfig[propertyName]) {
                  moduleRenderContext.params[propertyName] = moduleConfig[propertyName];
                }
              });
              return _context6.abrupt("return", moduleRenderContext);
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee4, this);
      }));
      function createModuleRenderContext(_x4, _x5) {
        return _createModuleRenderContext.apply(this, arguments);
      }
      return createModuleRenderContext;
    }()
  }]);
}();
export { Module as default, getModuleUniqueId, getMountElement, registerModuleClass };